var _a;
import { getAllActions } from "../generic/all.actions";
import { createRoutine } from "../utils/routine.utils";
import CONFIG from "./broker.config";
export var getDetail = (_a = getAllActions({
    entityName: CONFIG.ENTITY_NAME,
}), _a.getDetail), getPaged = _a.getPaged, update = _a.update, deleteObject = _a.deleteObject, create = _a.create;
// TODO:
export var getAllEmployees = createRoutine("BROKER_GET_ALL_EMPLOYEES");
